import type { PutShiftSettingRegionEntity } from './PutShiftSettingRegionEntity'

export class PutShiftSettingEntity {
  generateJobPeriodInDays?: number
  numberOfGeneratedDays?: number
  shiftSettingRegions?: Array<PutShiftSettingRegionEntity> | null
}
